import Breadcrumb from '@/components/feature/Breadcrumb';
import SEO from '@/components/feature/SEO';

const testimonials = [
  { name: '张先生', role: '资深影迷', content: '97影视是我每天必逛的电影网站，资源更新快、画质高清，关键是完全免费，已经推荐给身边所有朋友了！', rating: 5 },
  { name: '李女士', role: '家庭主妇', content: '周末最喜欢和孩子一起在97影视看动画片，资源丰富，分类清晰，非常适合全家一起观影。', rating: 5 },
  { name: '王同学', role: '大学生', content: '宿舍里大家都用97影视看电影，动作片和科幻片资源特别多，晚上熄灯前必刷一部！', rating: 4 },
  { name: '刘经理', rating: 5, role: 'IT从业者', content: '作为一个电影发烧友，97影视的片库让我非常满意。从经典老片到最新上映，应有尽有，强烈推荐！' },
];

const faqs = [
  { q: '97影视是否需要注册账号？', a: '97影视完全免费，无需注册即可观看所有电影资源。我们致力于为用户提供便捷的观影体验。' },
  { q: '97影视的电影资源多久更新一次？', a: '我们的内容团队每天都会更新最新的电影资源，确保用户能够第一时间观看到最新上映的热门影片。' },
  { q: '在97影视观看电影需要安装播放器吗？', a: '不需要。97影视采用先进的HTML5播放技术，直接在浏览器中即可流畅观看，无需安装任何第三方插件或播放器。' },
  { q: '97影视支持哪些设备观看？', a: '97影视全面支持PC端、平板和手机端观看，自适应不同屏幕尺寸，无论您使用什么设备，都能享受最佳观影体验。' },
  { q: '电影播放卡顿怎么办？', a: '我们提供了多条播放线路，如果遇到卡顿情况，可以尝试切换不同的播放线路。同时建议检查您的网络连接状态。' },
  { q: '如何向97影视反馈建议？', a: '您可以通过本页面的联系方式，或发送邮件到我们的官方邮箱，我们非常重视每一位用户的反馈和建议。' },
];

export default function AboutPage() {
  return (
    <>
      <SEO
        title="关于我们 - 97影视 | 品牌介绍、口碑评价与联系方式"
        description="了解97影视的品牌故事与发展历程。97影视致力于为影迷提供最新高清电影免费在线观看服务，拥有海量电影资源与极速播放体验。查看用户口碑评价与联系方式。"
        keywords="97影视,关于97影视,97影视介绍,电影网站,免费电影,联系方式,用户评价"
        canonical="https://www.97yingshi.com/about"
        ogTitle="关于我们 - 97影视"
        ogDescription="了解97影视的品牌故事，海量电影资源免费在线观看。"
        ogUrl="https://www.97yingshi.com/about"
        ogType="website"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于97影视',
            description: '97影视品牌介绍、口碑评价与联系方式',
            url: 'https://www.97yingshi.com/about',
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.q,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.a,
              },
            })),
          },
        ]}
      />

      <Breadcrumb
        items={[
          { label: '首页', href: '/' },
          { label: '关于我们' },
        ]}
      />

      <main className="max-w-[1400px] mx-auto px-4 md:px-6 py-6">
        <article>
          <header className="mb-8">
            <h1 className="text-xl md:text-3xl font-heading font-bold text-foreground-50 mb-2">
              关于97影视
            </h1>
            <p className="text-sm text-foreground-500">海量电影资源 · 极速流畅播放 · 完全免费观看</p>
          </header>

          <section className="mb-10 md:mb-14">
            <h2 className="text-lg font-heading font-bold text-foreground-50 mb-4">品牌故事</h2>
            <div className="bg-background-100 rounded-lg p-5 md:p-6 space-y-4">
              <p className="text-sm text-foreground-300 leading-relaxed">
                <strong className="text-foreground-100">97影视</strong>成立于2020年，是一家专注于提供<strong>高清电影在线观看</strong>服务的综合影视平台。自成立以来，我们始终秉持"让每个人都能轻松享受电影的魅力"的初心，致力于为广大影迷打造一个资源丰富、播放流畅、完全免费的观影天堂。
              </p>
              <p className="text-sm text-foreground-300 leading-relaxed">
                经过多年的发展和积累，97影视已建立起覆盖<strong>动作片、喜剧片、爱情片、科幻片、恐怖片、悬疑片、战争片、纪录片、动画片</strong>等九大品类的海量电影资源库，收录影片超过数千部，每日持续更新最新上映的热门影片。
              </p>
              <p className="text-sm text-foreground-300 leading-relaxed">
                我们的技术团队不断优化播放体验，采用先进的视频压缩与CDN加速技术，确保用户在任何网络环境下都能享受<strong>极速流畅的观影体验</strong>。无论是PC端还是移动端，97影视都能为您提供高清画质与低延迟的播放服务。
              </p>
            </div>
          </section>

          <section className="mb-10 md:mb-14">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
              {[
                { value: '5000+', label: '电影资源' },
                { value: '9', label: '电影分类' },
                { value: '1000万+', label: '月活跃用户' },
                { value: '99.9%', label: '播放成功率' },
              ].map((stat) => (
                <div key={stat.label} className="bg-background-100 rounded-lg p-4 text-center">
                  <div className="text-xl md:text-2xl font-heading font-bold text-primary-500">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-10 md:mb-14">
            <h2 className="text-lg font-heading font-bold text-foreground-50 mb-4">用户口碑</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {testimonials.map((t) => (
                <div key={t.name} className="bg-background-100 rounded-lg p-4 md:p-5">
                  <div className="flex items-center gap-1 mb-2">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`ri-star-fill text-xs ${i < t.rating ? 'text-primary-500' : 'text-foreground-600'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-300 leading-relaxed mb-3">{t.content}</p>
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-secondary-500 flex items-center justify-center">
                      <span className="text-xs font-bold text-background-50">{t.name[0]}</span>
                    </div>
                    <div>
                      <p className="text-xs font-medium text-foreground-200">{t.name}</p>
                      <p className="text-[10px] text-foreground-500">{t.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-10 md:mb-14">
            <h2 className="text-lg font-heading font-bold text-foreground-50 mb-4">联系我们</h2>
            <div className="bg-background-100 rounded-lg p-5 md:p-6">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-background-200 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-lg text-primary-500"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500">电子邮箱</p>
                    <p className="text-sm text-foreground-200">contact@97yingshi.com</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-background-200 flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-lg text-primary-500"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500">客服热线</p>
                    <p className="text-sm text-foreground-200">400-888-9797</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-background-200 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-lg text-primary-500"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-500">公司地址</p>
                    <p className="text-sm text-foreground-200">北京市朝阳区望京科技园</p>
                  </div>
                </div>
              </div>
              <div className="border-t border-background-300/30 pt-4">
                <p className="text-xs text-foreground-500">
                  工作时间：周一至周五 9:00 - 18:00（法定节假日除外）<br />
                  我们会在收到您的反馈后24小时内回复，感谢您对97影视的支持与信任！
                </p>
              </div>
            </div>
          </section>

          <section className="mb-6">
            <h2 className="text-lg font-heading font-bold text-foreground-50 mb-4">常见问题</h2>
            <div className="space-y-3">
              {faqs.map((faq) => (
                <details key={faq.q} className="group bg-background-100 rounded-lg overflow-hidden">
                  <summary className="flex items-center justify-between px-4 py-3 cursor-pointer hover:bg-background-200 transition-colors">
                    <span className="text-sm font-medium text-foreground-200">{faq.q}</span>
                    <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <div className="px-4 pb-3">
                    <p className="text-sm text-foreground-400 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </section>
        </article>
      </main>
    </>
  );
}